import { LayoutVariant } from '@uikit/components/Layout/interfaces';
import Layout from '@uikit/components/Layout/Layout';
import clsx from 'clsx';
import { MagazineLayoutProps } from './interfaces';
import styles from './MagazineLayout.module.scss';

const MagazineLayout = ({ children, className }: MagazineLayoutProps) => {
  return (
    <Layout
      className={clsx(styles.layout, className)}
      variant={LayoutVariant.FullWidth}
    >
      {children}
    </Layout>
  );
};

export default MagazineLayout;
